import types from './types';
import cartActions from './SavedAddressAction';

const initState = {
    loader: false,
    addressData: [],
    relatives: [],

};

export default function savedAddressReducer(state = initState, action) {
    switch (action.type) {

        case types.GET_DELIVERY_ADDRESS:
            return {
                ...state,
                loader: true,
            };


        case types.GET_DELIVERY_ADDRESS_SUCCESS:
            return {
                ...state,
                loader: false,
                addressData: action.payload,
            };



        default:
            return state;
    }
}
